import { z } from 'zod'

export const ZHsmKeyTypeMapping = z.object({
  id: z.string(),
  keyTypeName: z.string(),
  hybridKek: z.string(),
  createdBy: z.string(),
  createdAt: z.string(),
  tenant: z.string(),
  deactivatedAt: z.string().nullable(),
  deactivatedBy: z.string().nullable()
})

export type HsmKeyTypeMapping = z.infer<typeof ZHsmKeyTypeMapping>

export const ZHSMRegularKek = z.object({
  id: z.string(),
  label: z.string(),
  tenant: z.string(),
  use: z.number(),
  createdBy: z.string(),
  createdAt: z.string()
})

export type HsmRegularKEK = z.infer<typeof ZHSMRegularKek>

export interface SelectAssetList {
  asset_id: string
  serial_number: string
  asset_type: string
  template_name: string[] | null
  state: string | null
  firmware_version: string | null
  tag: string[]
}

export interface CreateRegularKekPostRequest {
  label: string
  tenant: string
  use: string
}

export interface CreateMappingPostRequest {
  hybridKek: string
  keyName: string
  tenant: string
}

export const Ztag = z.array(z.string())

export interface AdvanceFilterParameter {
  key: string
  operation: string
  value: string | string[]
  datatype?: string
}

export interface AdvanceFilterParameterParsed {
  key: string
  operation: string
  value: string | string[] | number | number[] | boolean | boolean[]
}

export type ConjuctionOptions = 'AND' | 'OR'

export interface AdvancedFilterPostRequest {
  conditions: AdvanceFilterParameter[]
  conjuction: ConjuctionOptions
}

export interface AdvancedFilterPostRequestBodyParsed {
  conditions: AdvanceFilterParameterParsed[]
  conjuction: ConjuctionOptions
}

export const ZAdvancedFilter = z.object({
  conditions: z.array(z.object({
    key: z.string(),
    operation: z.string(),
    value: z.string()
  }))
})

export const ZAssetForGroupObj = z.object(
  {
    asset_id: z.string(),
    serial_number: z.string(),
    firmware_version: z.string(),
    asset_type: z.string(),
    template_name: z.array(z.string()).nullable(),
    state: z.string().nullable(),
    tag: Ztag
  })
export interface Asset {
  id: string
  serialNumber: string
  assetType: string
  assetConfiguration: string
  tag: string
  state: string
}

export const ZAssetGroupDetails = z.object({
  group_id: z.string(),
  group_name: z.string(),
  status: z.string().nullable(),
  description: z.string(),
  group_type: z.string(),
  asset_type_name: z.string(),
  category_name: z.string(),
  no_of_assets: z.number(),
  asset_type_id: z.string()
})

export type AssetGroupDetails = z.infer<typeof ZAssetGroupDetails>

export const ZGroupsAssetObj = z.object(
  {
    asset_id: z.string(),
    serial_number: z.string(),
    firmware_version: z.string().optional(),
    asset_type: z.string(),
    template_name: z.array(z.string()).nullable(),
    state: z.string().nullable(),
    tag: Ztag
  })

export const ZAssetForGroup = z.object({
  total_count: z.number(),
  group_details: z.array(ZAssetForGroupObj)
})

export type AssetForGroup = z.infer<typeof ZAssetForGroup>
export type AssetForGroupObj = z.infer<typeof ZAssetForGroupObj>
export type Tag = z.infer<typeof Ztag>
export const ZGroupsAsset = z.object({
  total_count: z.number(),
  group_details: z.array(ZGroupsAssetObj)
})

export type GroupsAsset = z.infer<typeof ZGroupsAsset>
export type GroupsAssetObj = z.infer<typeof ZGroupsAssetObj>

export const ZUpdateGroupRequest = z.object({
  description: z.string(),
  assign_assets: z.string().array(),
  un_assign_assets: z.string().array(),
  assign_assets_select_all: z.boolean(),
  un_assign_assets_select_all: z.boolean(),
  search_assets_input: z.string(),
  is_edit_for_adding_assets: z.boolean(),
  conjuction: z.enum(['AND', 'OR', '']),
  conditions: z.array(z.object({
    key: z.string(),
    operation: z.string(),
    value: z.union([
      z.string(),
      z.array(z.string())
    ])
  }))
})

export type UpdateGroupRequest = z.infer<typeof ZUpdateGroupRequest>

export const ZHybridKek = z.object({
  id: z.string(),
  wrapperId: z.string(),
  label: z.string(),
  createdBy: z.string(),
  createdAt: z.string(),
  tenantId: z.string()
})

export type HybridKEK = z.infer<typeof ZHybridKek>

export interface CreateHybridKekPostRequest {
  wrap: string
  label: string
  tenant: string
}

export const ZHSMHybridKek = z.object({
  id: z.string().uuid(),
  wrapper: z.string().uuid(),
  label: z.string(),
  createdBy: z.string(),
  createdAt: z.string()
})
